import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { LOGGED_IN_USER } from "../../../enums/QueryKeys";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { returnSubmit } from "../../../enums/queryFunction/Submit";
import { HttpStatusCode } from "axios";
import logger from "../../../utils/logger";

export default function usePutProfile(url) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState(null);
  const queryClient = useQueryClient();

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      if (response?.status === HttpStatusCode.Ok) {
        setLoading(false);
        return true;
      }
    } catch (error) {
      logger.error("Mutation failed:", error);
    }
    setLoading(false);
    return false;
  };

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      queryClient.invalidateQueries([LOGGED_IN_USER]);
      setResult(true);
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
    result,
  };
}
